import { render, staticRenderFns } from "./EditorTable.vue?vue&type=template&id=e3a6329c&scoped=true&"
import script from "./EditorTable.vue?vue&type=script&lang=js&"
export * from "./EditorTable.vue?vue&type=script&lang=js&"
import style0 from "./EditorTable.vue?vue&type=style&index=0&id=e3a6329c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a6329c",
  null
  
)

export default component.exports